/* RSC Health - Homepage behaviors (rsc-home-mockup.html). One job: the rotating live-pricing
   card. Hero entrance is pure CSS; add-to-cart is handled globally by rsc-atc.js (add → /cart).
   Deals come from the section's <script data-rsc-deals> payload (prices in CENTS; us=0 → TODO).
   The hospital/insurance ("them") numbers are PLACEHOLDER settings RSC fills - never invented.
   No PHI, no analytics.
   2026-07-31 (Chad's copy pass): float badge now shows the dollar savings ("Save $531") and the
   save line reads "All-in price. No hidden fees, ever."; the card's Get-this-test CTA
   ([data-pa-cta]) follows the rotating deal's product URL and hides when a deal has no product. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rsc-home]');
  if (!root) return;

  var card = root.querySelector('[data-rsc-pricecard]');
  var dataEl = root.querySelector('[data-rsc-deals]');
  if (!card || !dataEl) return;

  var deals = [];
  try { deals = JSON.parse(dataEl.textContent) || []; } catch (e) { deals = []; }
  if (!deals.length) { card.style.display = 'none'; return; }

  var el = {
    name: card.querySelector('[data-pa-name]'), us: card.querySelector('[data-pa-us]'),
    them: card.querySelector('[data-pa-them]'), save: card.querySelector('[data-pa-save]'),
    float: card.querySelector('[data-pa-float]'), themRow: card.querySelector('.pa-row.them'),
    cta: card.querySelector('[data-pa-cta]')
  };

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString(undefined, { maximumFractionDigits: (n % 1 ? 2 : 0) });
  }

  function render(d) {
    // fade the changing bits
    [el.name, el.us, el.them, el.save, el.float, el.cta].forEach(function (x) {
      if (!x) return; x.classList.remove('fade'); void x.offsetWidth; x.classList.add('fade');
    });
    el.name.textContent = d.name || 'Featured test';
    if (d.us > 0) { el.us.textContent = money(d.us); }
    else { el.us.innerHTML = '$- <span class="pa-todo">TODO</span>'; }

    if (d.them > 0) {
      if (el.themRow) el.themRow.style.display = '';
      el.them.textContent = money(d.them);
    } else if (el.themRow) {
      el.themRow.style.display = 'none';
    }

    if (d.us > 0 && d.them > d.us) {
      var save = d.them - d.us;
      el.save.textContent = 'All-in price. No hidden fees, ever.';
      el.float.textContent = 'Save ' + money(save);
    } else if (d.us > 0) {
      el.save.textContent = 'All-in price. No surprise bills';
      el.float.textContent = 'All-in';
    } else {
      el.save.textContent = 'All-in price coming soon';
      el.float.textContent = 'All-in';
    }

    if (el.cta) {
      if (d.url) { el.cta.style.display = ''; el.cta.setAttribute('href', d.url); }
      else { el.cta.style.display = 'none'; }
    }
  }

  var i = 0;
  render(deals[0]);
  if (deals.length > 1) {
    setInterval(function () { i = (i + 1) % deals.length; render(deals[i]); }, 3200);
  }
})();
